import { getWhatsNewData } from './api';

export const MAX_VISIBLE_VERSIONS = 3;

export const selectWhatsNewVersions = () => getWhatsNewData().versions.slice(0, MAX_VISIBLE_VERSIONS);

export const selectWhatsNewChangelogUrl = () => getWhatsNewData().changelogUrl;
